import globeSvg from 'assets/icons/globe.svg';
import Auth from 'modules/Auth';
import PageSize from 'lib/PageSize';
import Button, { Color, Size } from 'lib/Button';
import Table from 'lib/Table';
import { TableHeight, TableRowHeight } from 'lib/Table/Table.types';
import { PermissionsEnum } from 'consts/permissions';
import { Filter } from 'store/pagesFilters/types';
import { Creative } from 'components/common/types/Creative.types';
import { CreativeAdministrationPageFilters } from '../Filters/Filters.types';
import useCreatives from './useCreatives';

type CreativesProps = {
  onOpenDialog: () => void;
  setSelectedCreatives: (creatives: Creative[]) => void;
  areMarketsUpdated: boolean;
  hasUserSelectedCreatives: boolean;
  filters: Filter<CreativeAdministrationPageFilters>;
};

const Creatives = ({
  onOpenDialog,
  setSelectedCreatives,
  areMarketsUpdated,
  hasUserSelectedCreatives,
  filters,
}: CreativesProps): React.ReactElement => {
  const { columnDefs, pageSize, handlePageSizeChange, handleSelectionChanged, getTableApi } = useCreatives({
    setSelectedCreatives,
    areMarketsUpdated,
    filters,
  });

  return (
    <>
      <div className="row my-4 flex justify-between">
        <div className="flex items-center ml-3">
          <PageSize
            dataTestId="page-size-selection"
            onPageSizeChange={handlePageSizeChange}
            pageSize={pageSize}
            pageInfoText="creatives per page"
          />
        </div>
        {Auth.hasPermission(PermissionsEnum.ADMINISTRATION_ASSIGN_MARKET) && (
          <Button
            onClick={onOpenDialog}
            size={Size.LARGE}
            color={Color.TERTIARY}
            isDisabled={!hasUserSelectedCreatives}
            svg={globeSvg}
            label="Assign market"
            classNames="mr-4"
          />
        )}
      </div>
      <Table
        dataTestId="creatives-table"
        key={pageSize}
        columnDefs={columnDefs}
        getTableApi={getTableApi}
        extraGridOptions={{
          rowModelType: 'infinite',
          rowHeight: TableRowHeight.NORMAL,
          pagination: true,
          paginationPageSize: pageSize,
          cacheBlockSize: pageSize,
          maxBlocksInCache: 1,
          rowSelection: 'multiple',
          suppressRowClickSelection: true,
          onSelectionChanged: handleSelectionChanged,
          enableCellTextSelection: true,
          domLayout: 'autoHeight',
        }}
        tableHeight={TableHeight.AUTO}
      />
    </>
  );
};

export default Creatives;
